/**
 * ErrorMessages Component
 *
 * Displays validation errors for the transaction form
 */
import styles from './ErrorMessages.module.css';

function ErrorMessages({ errors }) {
    if (Object.keys(errors).length === 0) {
        return null;
    }

    const renderCategoryErrors = () => {
        if (!errors.categories) return null;

        return Object.keys(errors.categories).map(index => (
            <div key={index}>
                {errors.categories[index].category && (
                    <div className={styles.errorMessage}>
                        Category {parseInt(index) + 1}: {errors.categories[index].category}
                    </div>
                )}
                {errors.categories[index].amount && (
                    <div className={styles.errorMessage}>
                        Category {parseInt(index) + 1} Amount: {errors.categories[index].amount}
                    </div>
                )}
            </div>
        ));
    };

    return (
        <div className={styles.errorContainer}>
            {errors.transactionType && (
                <div className={styles.errorMessage}>
                    {errors.transactionType}
                </div>
            )}
            {errors.currentUser && (
                <div className={styles.errorMessage}>
                    {errors.currentUser}
                </div>
            )}
            {errors.amount && (
                <div className={styles.errorMessage}>
                    {errors.amount}
                </div>
            )}
            {errors.description && (
                <div className={styles.errorMessage}>
                    {errors.description}
                </div>
            )}
            {errors.date && (
                <div className={styles.errorMessage}>
                    {errors.date}
                </div>
            )}
            {errors.adjustmentFromCategory && (
                <div className={styles.errorMessage}>
                    {errors.adjustmentFromCategory}
                </div>
            )}
            {errors.adjustmentToCategory && (
                <div className={styles.errorMessage}>
                    {errors.adjustmentToCategory}
                </div>
            )}
            {errors.adjustmentCategories && (
                <div className={styles.errorMessage}>
                    {errors.adjustmentCategories}
                </div>
            )}
            {errors.categorySum && (
                <div className={styles.errorMessage}>
                    {errors.categorySum}
                </div>
            )}
            {renderCategoryErrors()}
        </div>
    );
}

export default ErrorMessages;
